import { render, staticRenderFns } from "./BlogTopicIndexPage.vue?vue&type=template&id=32b410fa&"
import script from "./BlogTopicIndexPage.vue?vue&type=script&lang=js&"
export * from "./BlogTopicIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports